<template>
  <v-row v-if="showBanner">
    <v-card
      id="business_account_ivitation_banner"
      align="stretch"
      width="100%"
      class="pt-6 pl-6 pr-6 pb-6 mb-3 ba-banner"
      flat
    >
      <v-row class="px-0 py-0" align="center">
        <v-col cols="12" class="d-flex align-center">
          <v-card-text class="mt-0 pt-0 flex-grow-1">
            {{ bannerExplainer }}
          </v-card-text>

          <v-btn
            class="mx-4"
            color="success"
            depressed
            @click="acceptInvitation"
          >
            {{ banner.btnText }}
          </v-btn>

          <v-btn
            class="mx-4 ba-banner__cta"
            depressed
            @click="declineInvitation"
          >
            {{ banner.btnDeclineInvitationText }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import users from '@/services/api/users'
import businessAccount from '@/services/api/businessAccount'
import { showToastError, showToastSuccess } from '@/event-bus'

export default {
  data() {
    return {
      banner: {
        explainer: this.$t('dashboard.banners.businessAccount.invitedToBABanner', { baName: this.invitedBA?.name }),
        btnPath: '/user/profile',
        btnText: this.$t('dashboard.banners.businessAccount.acceptInvitation'),
        btnDeclineInvitationText: this.$t('dashboard.banners.businessAccount.declineInvitation')
      },
      invitedBA: null,
      showBanner: false
    }
  },
  computed: {
    bannerExplainer() {
      return this.$t('dashboard.banners.businessAccount.invitedToBABanner', { baName: this.invitedBA?.name })
    }
  },
  async mounted() {
    await this.checkBannerVisibility()
  },
  methods: {
    async checkBannerVisibility() {
      try {
        const invitations = await users.getMyBusinessAccountInvitations()
        if (invitations && invitations.businessAccounts?.length > 0) {
          this.invitedBA = invitations.businessAccounts[0]
          this.showBanner = true
        } else {
          this.showBanner = false
        }
        // console.log(this.showBanner, this.invitedBA)
      } catch (error) {
        this.showBanner = false
      }
    },

    async acceptInvitation() {
      try {
        await businessAccount.acceptInvitation(this.invitedBA.id)
        showToastSuccess(this.$t('businessAccount.members.invitationSucces'))
        this.showBanner = false
        setTimeout(() => {
          location.href = window.location.origin
        }, 2000)
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    },

    async declineInvitation() {
      try {
        await businessAccount.declineInvitation(this.invitedBA.id)
        showToastSuccess(this.$t('businessAccount.members.declineSucces'))
        this.showBanner = false
      } catch (error) {
        const errorMsg = this.getErrorMessage(error)
        showToastError(errorMsg)
      }
    }

  }
}
</script>
